<template>
  <div class="container">
    <section>
      <MainPage />
    </section>
    <Footer />
  </div>
</template>

<script>

import Footer from "./Footer.vue";

import MainPage from "./MainPage.vue";

export default {
  name: "Content",
  data() {
    return {
      title: "Content",
    };
  },

  components: {
    MainPage,
    Footer,
  },
  methods: {
    scrollToTop() {
      const width = window.innerWidth;
      let heightOfForm = document.getElementById("form__wrapper").scrollHeight;
      if (width > 768) {
        window.scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      } else {
        window.scroll({
          top: heightOfForm,
          left: 0,
          behavior: "smooth",
        });
      }
    },
  },
};
</script>
